<template>

  <div class="WizardThankYou">

    <div class="textBox">
      <h2 class="title">{{ content.title }}</h2>
      <img :src="checkmark.src" class="checkmark">
      <p class="message">{{ content.message }}</p>
      <div v-if="content.done" class="doneShelf">
        <CtaButton :text="content.done" @click="$emit('formDone')" class="doneButton --dark-blue" />
      </div>
    </div>

    <div v-if="content.cards" class="cards">
      <div v-for="card, index in content.cards" :key="index" class="card">
        <div class="cardIconShelf">
          <img :src="icons[card.icon].src">
        </div>
        <h3 class="cardTitle">{{card.title}}</h3>
        <p class="cardBody">
          <strong v-if="card.subtitle">{{card.subtitle}}</strong>
          {{card.description}}
        </p>
        <div class="cardCtaShelf">
          <CtaLink v-bind="card.cta" />
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import checkmark from '../assets/thank-you/checkmark.svg'
import iconAssetsBlue from '../assets/thank-you/icon-assets-blue.svg'
import iconAssetsYellow from '../assets/thank-you/icon-assets-yellow.svg'
import iconCloudPurple from '../assets/thank-you/icon-cloud-purple.svg'
import iconDashcamPurple from '../assets/thank-you/icon-dashcam-purple.svg'
import iconDriverYellow from '../assets/thank-you/icon-driver-yellow.svg'
import iconWirelessBlue from '../assets/thank-you/icon-wireless-blue.svg'

import thankYouContent from '../data/thank-you.json'

const icons = {
  'icon-assets-blue': iconAssetsBlue,
  'icon-assets-yellow': iconAssetsYellow,
  'icon-cloud-purple': iconCloudPurple,
  'icon-dashcam-purple': iconDashcamPurple,
  'icon-driver-yellow': iconDriverYellow,
  'icon-wireless-blue': iconWirelessBlue,
}

export default {
  inject: ['locale'],
  props: {
    requestType: String,
  },
  data() {
    return {
      checkmark,
      icons,
    }
  },
  computed: {
    content() {
      // Note that requestType may be 'sales', 'support', or 'salesShort'
      const thankYouType = this.requestType === 'support' ? 'support' : 'sales'
      return thankYouContent[this.locale][thankYouType]
    },
  },
}
</script>


<style scoped>

.WizardThankYou {
  padding-top: var(--spacing-13);
  padding-bottom: var(--spacing-9);
  padding-left: var(--wizard-gutter-width-left);
  padding-right: var(--wizard-gutter-width-right);
}

.title {
  font-weight: 600;
  font-size: var(--font-size-7);
  color: var(--text-color-black);
}

.textBox {
  margin: 0 auto;
  max-width: 24rem;
  text-align: center;
}

.checkmark {
  display: block;
  margin: var(--spacing-9) auto;
}

.message {
  font-weight: 500;
  font-size: var(--font-size-1);
  line-height: 1.5;
  color: var(--text-color-black);
}

.doneShelf {
  margin-top: var(--spacing-8);
}

.doneButton {
  min-width: 12rem;
}

.cards {
  margin-top: var(--spacing-16);
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--spacing-6);
}

.card {
  border: thin solid var(--hairline-color);
  border-radius: 8px;
  padding: var(--spacing-9);
  display: flex;
  flex-direction: column;
}

.cardIconShelf {
  height: 44px;
}

.cardTitle {
  margin-top: var(--spacing-6);
  font-weight: 600;
  font-size: var(--font-size-4);
  color: var(--text-color-black);
}

.cardBody {
  margin-top: var(--spacing-3);
  font-weight: 400;
  font-size: var(--font-size-3);
  line-height: 1.5;
  color: var(--text-color-dark);
}

.cardCtaShelf {
  margin-top: auto;
  padding-top: var(--spacing-10);
}

@media (--screen-lg) {

  .cards {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
</style>
